// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SettingIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SettingIcon" ref={forwardedRef} {...props}>
      <path d="M13 10.002a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1.5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
      <path d="M12.498 2h-5v2.002a6.5 6.5 0 0 0-1.44.833L4.324 3.834l-2.5 4.33 1.732 1a6.6 6.6 0 0 0-.002 1.668L1.826 11.83l2.5 4.33 1.725-.996a6.5 6.5 0 0 0 1.45.84v1.986h5.001v-1.986a6.5 6.5 0 0 0 1.452-.842l1.722.994 2.5-4.33-1.726-.996a6.6 6.6 0 0 0-.002-1.673l1.726-.997-2.5-4.33-1.733 1a6.5 6.5 0 0 0-1.443-.832zm2.246 9.592 1.387.8-1 1.73-1.389-.802a5 5 0 0 1-2.746 1.583v1.607H8.998V14.9a5 5 0 0 1-2.739-1.584l-1.396.806-.999-1.73 1.395-.805a5 5 0 0 1-.257-1.586 5 5 0 0 1 .254-1.579L3.863 7.62l1-1.73 1.391.803a5 5 0 0 1 2.744-1.59V3.499h1.998v1.603a5 5 0 0 1 2.749 1.586l1.386-.8.999 1.73-1.385.8a5 5 0 0 1 .257 1.585 5 5 0 0 1-.258 1.59" />
    </SvgIcon>
  );
});

/**
 * Platform-wide configurations, often to change defaults
 * @public
 */
export const SettingIcon = /* @__PURE__ */ Object.assign(SettingIconComponent, {
  displayName: 'SettingIcon',
});
